import withErrorWrapper from '../../../hoc/WithErrorWrapper';
import view from './ProductsReportView';

export default withErrorWrapper(view);
